export default [

    {
        path: '',
        name: 'autenticacao',
        redirect: { name: 'autenticacao-login' },
    },

    {
        path: '/login',
        name: 'autenticacao-login',
        component: () => import('@/aplicacao/_autenticacao/Login'),
    },

    {
        path: '/cadastrar-primeira-senha',
        name: 'autenticacao-cadastrar-primeira-senha-iniciar',
        component: () => import('@/aplicacao/_autenticacao/CadastroIniciar'),
    },

    {
        path: '/cadastrar-primeira-senha/definir',
        name: 'autenticacao-cadastrar-primeira-senha-definir',
        component: () => import('@/aplicacao/_autenticacao/CadastroConcluir'),
    },

    {
        path: '/esqueci-minha-senha',
        name: 'autenticacao-esqueci-minha-senha-iniciar',
        component: () => import('@/aplicacao/_autenticacao/ResetIniciar'),
    },

    {
        path: '/esqueci-minha-senha/redefinir',
        name: 'autenticacao-esqueci-minha-senha-redefinir',
        component: () => import('@/aplicacao/_autenticacao/ResetConcluir'),
    },

]
